import {
  PromotionContestDeliveryType,
  PromotionContestRewardType,
  PromotionContestV1,
} from './types/ContestTypes';

export { PromotionContestRewardType as ContestRewardType };
export { PromotionContestDeliveryType as ContestDeliveryType };

export const CONTEST_MAX = {
  trigger: 200,
  title: 500,
  message: 10000,
} as const;

export function createEmptyContestV1Values(): PromotionContestV1 {
  return {
    triggerKey: '',
    episodeUuid: '',
    rewardType: PromotionContestRewardType.Sapphires,
    rewardAmount: 0,
    deliveryType: PromotionContestDeliveryType.Immediate,
    title: '',
    message: '',
  };
}

export function contestV1ApiToFormValues(
  contest: PromotionContestV1 | null | undefined,
): PromotionContestV1 {
  if (!contest) {
    return createEmptyContestV1Values();
  }
  const rewardType = contest.rewardType === PromotionContestRewardType.Hearts
    ? PromotionContestRewardType.Hearts
    : PromotionContestRewardType.Sapphires;
  return {
    triggerKey: contest.triggerKey ?? '',
    episodeUuid: contest.episodeUuid ?? '',
    rewardType,
    rewardAmount: Number(contest.rewardAmount) || 0,
    deliveryType: PromotionContestDeliveryType.Immediate,
    title: contest.title ?? '',
    message: contest.message ?? '',
  };
}

export function isContestV1Populated(v: PromotionContestV1): boolean {
  const t = (s: string) => String(s ?? '').trim();
  return Boolean(t(v.episodeUuid) || t(v.title) || t(v.message));
}
